import { gql } from '@apollo/client';
import React from 'react';
import { Listing } from '../gql/graphql';
import AffirmEstimateSmall from './affirm_estimate_small';

interface IProps {
  listing: Listing;
}

export const fullFinancingFieldsFragment = gql`
  fragment FullFinancingFields on Listing {
    _id
    estimatedMonthlyPaymentPlan {
      estimatedMonthlyPayment {
        display
      }
      maxTermMonth
      availableTermMonths
      lowestAprAtMaxTerm
      zeroPercentFinancingPlan
      splitPay
    },
    pricing {
      buyerPrice {
        display
      }
    },
  }
`;

function AffirmEstimateListingCardCTA({ listing }: IProps) {
  const { estimatedMonthlyPaymentPlan, pricing } = listing;
  const buyerPrice = pricing?.buyerPrice?.display;

  const emptyRender = !(estimatedMonthlyPaymentPlan?.estimatedMonthlyPayment && buyerPrice);

  if (emptyRender) { return null; }

  const {
    availableTermMonths,
    maxTermMonth,
    lowestAprAtMaxTerm,
    zeroPercentFinancingPlan,
    splitPay,
  } = estimatedMonthlyPaymentPlan;

  const estimatedMonthlyPayment = estimatedMonthlyPaymentPlan.estimatedMonthlyPayment.display;

  return (
    <AffirmEstimateSmall
      estimatedMonthlyPayment={estimatedMonthlyPayment}
      buyerPrice={buyerPrice}
      maxTermMonth={maxTermMonth}
      availableTermMonths={availableTermMonths}
      zeroPercentFinancing={zeroPercentFinancingPlan}
      lowestAprAtMaxTerm={lowestAprAtMaxTerm}
      splitPay={splitPay}
    />
  );
}

export default AffirmEstimateListingCardCTA;
